import { render, staticRenderFns } from "./IssueArticleListControl.vue?vue&type=template&id=918fa2e4&"
import script from "./IssueArticleListControl.vue?vue&type=script&lang=js&"
export * from "./IssueArticleListControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports